import {
    MultiSelect,
    MultiSelectOption,
    MultiSelectProps,
    OptionValue,
} from 'components/forms/multiselect/MultiSelect';
import { BaseInlineEditorProps, InlineEditor } from 'components/inline_edit/InlineEditor';
import { NoValue } from 'components/no_value/NoValue';
import { useInlineEditor } from 'custom_hooks/useInlineEditor';
import { joinNodes } from 'utils/joinNodes';

export type MultiSelectInlineEditorProps = BaseInlineEditorProps<
    MultiSelectOption<OptionValue>[],
    MultiSelectOption<OptionValue>[]
> &
    Readonly<{
        multiSelectConfig: Partial<Omit<MultiSelectProps<OptionValue>, 'onChange'>> & {
            options: MultiSelectOption<OptionValue>[];
        };
    }>;

export function MultiSelectInlineEditor({
    value,
    multiSelectConfig,
    renderValue,
    validate,
    onConfirm,
    onClose,
    isDisabled,
    editorClass,
    editorStyle,
}: MultiSelectInlineEditorProps) {
    const {
        valueToRender,
        inputValue,
        error,
        setInputValue,
        isEditing,
        isConfirming,
        openEditor,
        closeEditor,
        confirm,
        canConfirm,
    } = useInlineEditor<MultiSelectOption<OptionValue>[]>({
        value,
        validate,
        onConfirm,
        onClose,
    });
    return (
        <InlineEditor
            value={
                renderValue ? (
                    renderValue(valueToRender)
                ) : (
                    <>
                        {valueToRender !== undefined ? (
                            joinNodes(
                                valueToRender.map((v) => v.label ?? v.title),
                                ', '
                            )
                        ) : (
                            <NoValue />
                        )}
                    </>
                )
            }
            editor={
                <MultiSelect
                    {...multiSelectConfig}
                    options={multiSelectConfig.options}
                    selectedOptions={inputValue ?? []}
                    onChange={(e) => setInputValue(e.selected)}
                />
            }
            editorClass={editorClass}
            editorStyle={editorStyle}
            error={error}
            canClose={!isConfirming}
            canEdit={!isConfirming}
            canConfirm={canConfirm}
            isEditing={isEditing}
            isDisabled={isDisabled || isConfirming}
            isPending={isConfirming}
            onClose={closeEditor}
            onEdit={openEditor}
            onConfirm={confirm}
        />
    );
}
